<script>

	import {usuario} from '../store.js'
	export let handler = () => console.log("Unhandled action")

	function aceptar(){
		usuario.set({})
		localStorage.removeItem('UPM_USER')
		salir()
	}

	function salir(){
		handler({response:0,view_dst:"catalogo"})
	}	

</script>

<div class="modal" on:click|self={salir}>
	<div class="card responsive-margin">

		<div class="section responsive-padding bg-gray-200">
			<p>{ $usuario.email }</p>
			<p><small>Vas a salir del sistema...</small></p>
		</div>

		<div class="section" style="text-align: right;">
			{#if ( $usuario.nosale !== 1)}
				<span>{ $usuario.nosale }</span>
			{/if}
			<button class="ok" on:click={ aceptar }>Ok</button>
			<button class="cancel" on:click={ salir }>Cancel</button>
		</div>
		<!-- <pre>{JSON.stringify($usuario)}</pre> -->
	</div>
</div>			